import React from "react";
import {
  FbTypeography,
  FbBreadcrumbs,
  FbmakeStyles,
} from "@flexibees/core";
import { withRouter } from "react-router-dom";

const useStyles = FbmakeStyles({
  root: {
    fontFamily: "Manrope",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "13px",
    color: "#000000",
    textTransform: "capitalize",
    cursor: "pointer",
  },
  lastItem: {
    fontSize: "13px",
    textTransform: "capitalize",
  },
});

const hasNumber = (value) => /\d/.test(value);

const restrictedRoutes = [
  "update",
  "view",
  "assign",
  "detail",
  "details",
];

const getBreadcrumbLabel = (item) => {
  const labels = {
    projects: "All Projects",
    update: "Update Project Details",
    assign: "Assign Recruiter",
    view: "Recruitment Workflow",
    detail: "Project Details",
    details: "Candidate Details",
    candidates: "All Candidates",
  };

  return labels[item] || item;
};

const BreadCrumbs = (props) => {
  const { location, history } = props;
  const classes = useStyles();

  const pathNames = location.pathname
    .split("/")
    .filter(Boolean);

  const handleRoute = (route) => {
    if (restrictedRoutes.includes(route)) {
      return;
    }

    history.push(`/admin/${route}`);
  };

  return (
    <FbBreadcrumbs separator=">">
      {pathNames.map((item, index) => {
        const lastItem =
          index === pathNames.length - 1;

        if (
          hasNumber(item) ||
          item === "admin"
        ) {
          return null;
        }

        const label =
          getBreadcrumbLabel(item);

        return (
          <FbTypeography
            key={item}
            className={
              lastItem
                ? classes.lastItem
                : classes.root
            }
            onClick={
              lastItem
                ? undefined
                : () => handleRoute(item)
            }
          >
            {label}
          </FbTypeography>
        );
      })}
    </FbBreadcrumbs>
  );
};

export default withRouter(BreadCrumbs);